import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResidenceSection } from '../ResidenceSection';
import { Apartment } from '../../../../graphql/graphql';
import {
  ApartmentsInfoContainer,
  DeveloperContainer,
  DeveloperImage,
  DeveloperTitle
} from './styled';
import { ApartmentInfo } from '../../ApartmentInfo';

interface MainInfoProps {
  companyName?: string;
  logoUrl?: string;
  deadline?: string | null;
  priceMin?: number | null;
  currency?: string;
  apartments?: Apartment[] | null;
  hasBillOfSale?: boolean;
}

export const MainInfo: React.FC<MainInfoProps> = ({
  companyName,
  logoUrl,
  deadline,
  priceMin,
  currency,
  apartments,
  hasBillOfSale
}) => {
  const { t } = useTranslation();

  return (
    <ResidenceSection>
      <DeveloperContainer>
        {logoUrl && (
          <DeveloperImage
            src={logoUrl}
            alt={t('residences.logo', { name: companyName })}
            width={60}
            height={60}
          />
        )}

        {companyName && (
          <DeveloperTitle tag="title_4_new" data-cy="developer-title">
            {t('residences.title', { name: companyName })}
          </DeveloperTitle>
        )}
      </DeveloperContainer>

      <ApartmentsInfoContainer>
        <ApartmentInfo
          deadline={deadline}
          priceMin={priceMin}
          currency={currency}
          apartments={apartments}
          hasBillOfSale={hasBillOfSale}
        />
      </ApartmentsInfoContainer>
    </ResidenceSection>
  );
};
